export default __webpack_public_path__ + "static/media/icon-dilution-addtion-volume.6393d0eb.svg";